module.exports = __webpack_public_path__ + "media/images/top/design-d697fe96ce5a25af87ac531727fe2884.jpg";